import React from "react";
import "./dataNotFound.css";
const DataNotFound = () => {
  return (
    <div className="data-not-found">
      <div className="data_not_found_img">
        <img
          src={require("../../assets/images/data-not-found.png")}
          className="img-fluid"
          alt="data-not-found"
          loading="lazy"
        />
      </div>
      <div className="data_not_found_info">
        <h6 className="d_n_f_title">डेटा सापडला नाही!</h6>
        <p className="d_n_f_para">
          मुख्य दिवसाचा डेटा रिकामा आहे किंवा तुमचे फिल्टर समायोजित करण्याचा
          प्रयत्न करा.
        </p>
      </div>
    </div>
  );
};

export default DataNotFound;
